<template>
    <div>
        <loading :active.sync="loadingContent" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Syarat & Ketentuan</div>
        </div>
        <div id="appCapsule" v-if="!loadingContent">
            <div class="section inset mt-2">
                <div class="accordion" id="tos">
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed" type="button" data-toggle="collapse" :data-target="'#TOS0'">
                                <b>Pendahuluan</b>
                            </button>
                        </div>
                        <div :id="'TOS0'" class="accordion-body collapse" data-parent="#tos">
                            <div class="accordion-content">
                                <p>Syarat & ketentuan yang ditetapkan di bawah ini mengatur pemakaian layanan yang ditawarkan oleh {{ VUE_ENV.VUE_APP_NAME }} terkait penggunaan aplikasi {{ VUE_ENV.VUE_APP_NAME }}. Pengguna disarankan membaca dengan seksama karena dapat berdampak kepada hak dan kewajiban Pengguna di bawah hukum.</p>
                                <p>Dengan mendaftar dan/atau menggunakan Aplikasi {{ VUE_ENV.VUE_APP_NAME }}, maka pengguna dianggap telah membaca, mengerti, memahami dan menyutujui semua isi dalam Syarat & ketentuan. Syarat & ketentuan ini merupakan bentuk kesepakatan yang dituangkan dalam sebuah perjanjian yang sah antara Pengguna dengan {{ VUE_ENV.VUE_APP_NAME }}. Jika pengguna tidak menyetujui salah satu, sebagian, atau seluruh isi Syarat & ketentuan, maka pengguna tidak diperkenankan menggunakan layanan di Aplikasi {{ VUE_ENV.VUE_APP_NAME }}.</p>
                            </div>
                        </div>
                    </div>
                    <div class="item" v-for="(item, index) in tos" :key="index">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#TOS'+item.id">
                                <b>{{ item.title }}</b>
                            </button>
                        </div>
                        <div :id="'TOS'+item.id" class="accordion-body collapse" data-parent="#tos">
                            <div class="accordion-content">
                                <div class="p-1" v-html="item.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import $axios from './../../api.js'
export default {
    data() {
        return {
            loadingContent: true,
            tos: []
        }
    },
    created() {
        this.getData()
    },
    computed: {
        ...mapState(['VUE_ENV'])
    },
    methods: {
        getData(){
            $axios.get('/tos')
            .then((response) => {
                this.tos = response.data.data
                this.loadingContent = false
            })
        }
    }
}
</script>